import React, { useEffect, useState } from "react";
import { Checkbox, DatePicker, Form, Modal, message } from "antd";
import dayjs from "dayjs";
import { fillSprNumberDays } from "./spr-number-api";

/**
 * Диалог «Заполнение графика» (Delphi TFrmActFillGraph / ANumFill).
 */
const SprNumberFillModal = ({ open, numbers = [], onClose, onFilled }) => {
  const [form] = Form.useForm();
  const [busy, setBusy] = useState(false);
  const list = (Array.isArray(numbers) ? numbers : []).filter((n) => n?.idNumber != null);
  const hasNumbers = list.length > 0;
  const onlyLabel =
    list.length === 1
      ? `Только номер ${(list[0].name || "").trim() || list[0].idNumber}`
      : `Только выбранные номера (${list.length})`;

  useEffect(() => {
    if (!open) return;
    const today = dayjs().startOf("day");
    form.setFieldsValue({
      dateBeg: today,
      dateEnd: today,
      onlySelected: hasNumbers
    });
  }, [open, hasNumbers, form]);

  const onOk = async () => {
    try {
      const values = await form.validateFields();
      const beg = values.dateBeg;
      const end = values.dateEnd;
      if (!beg || !end) {
        message.error("Укажите период");
        return;
      }
      if (end.isBefore(beg, "day")) {
        message.error("Конец периода раньше начала");
        return;
      }

      const onlySelected = !!values.onlySelected;
      if (onlySelected && !hasNumbers) {
        message.error("Выберите номер");
        return;
      }

      setBusy(true);
      const targets = onlySelected ? list : [null];
      let inserted = 0;
      let rooms = 0;
      for (const number of targets) {
        const result = await fillSprNumberDays({
          dateBeg: beg.format("YYYY-MM-DD"),
          dateEnd: end.format("YYYY-MM-DD"),
          onlySelected: number != null,
          ...(number != null ? { idNumber: number.idNumber } : {})
        });
        inserted += Number(result?.inserted ?? result?.Inserted) || 0;
        rooms += Number(result?.rooms ?? result?.Rooms) || 0;
      }
      message.success(
        inserted > 0
          ? `График заполнен: добавлено ${inserted} дн. (${rooms} ном.)`
          : "График заполнен: новых дней нет"
      );
      onFilled?.({ inserted, rooms });
      onClose?.();
    } catch (e) {
      if (e?.errorFields) return;
      message.error(e.message || "Не удалось заполнить график");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal
      className="spr-number-fill-modal"
      title="Заполнение графика"
      open={open}
      onCancel={busy ? undefined : onClose}
      onOk={onOk}
      okText="Выполнить"
      cancelText="Закрыть"
      confirmLoading={busy}
      destroyOnClose
      width={420}
    >
      <Form form={form} layout="vertical" requiredMark={false} className="spr-number-fill-form">
        <Form.Item
          name="dateBeg"
          label="Начало периода"
          rules={[{ required: true, message: "Укажите начало" }]}
        >
          <DatePicker format="DD.MM.YYYY" style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item
          name="dateEnd"
          label="Окончание периода"
          rules={[{ required: true, message: "Укажите окончание" }]}
        >
          <DatePicker format="DD.MM.YYYY" style={{ width: "100%" }} />
        </Form.Item>
        {hasNumbers ? (
          <Form.Item name="onlySelected" valuePropName="checked">
            <Checkbox>{onlyLabel}</Checkbox>
          </Form.Item>
        ) : (
          <div className="spr-number-fill-form__hint">
            Будут заполнены все номера с категорией.
          </div>
        )}
      </Form>
    </Modal>
  );
};

export default SprNumberFillModal;
